export default "__VITE_ASSET__BzUNtqtH__"